<template>
    <div>
        <div v-if="treeData.length > 0">
            <!-- <vue-draggable-nested-tree :data="treeData" v-bind:class="isDraggable"  v-bind:draggable="draggable">
                <div slot-scope="{data, store}">
                    <template v-if="!data.isDragPlaceHolder">
                        <div class="clearfix draggable-item" v-bind:class="{'has-children': data.children && data.children.length}">
                            <div class="item-contents">
                                <a class="btn-toggle-nested" v-if="data.children && data.children.length" @click="store.toggleOpen(data)">
                                    <span v-if="data.open" class="">
                                        <i class="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                    </span>
                                    <span v-else class="">
                                        <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                                    </span>
                                </a>
                                <span>{{data.name}}</span>
                            </div>
                            <a class="btn btn-outline-primary btn-editable" :href="'/concrete-entity/' + genericEntityData.id + '/edit/' + data.id">Edit</a>
                        </div>
                    </template>
                </div>
            </vue-draggable-nested-tree> -->
        </div>
        <div v-else>
            <div class="card panel panel-default actions card-empty-tree">
                <div class="card-block">
                    <p style="margin: 0;" class="text-center"><strong>No items found</strong></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    // import {DraggableTree} from 'vue-draggable-nested-tree'
    // import {breadthFirstSearch} from 'tree-helper'
    import axios from 'axios';


    export default {
        name: 'tree-listing',
        props: ['entityOptionData','genericEntityData', 'isDraggable'],
        components: {
            // 'vue-draggable-nested-tree':DraggableTree,
        },
        data() {
            return {
                draggable: this.isDraggable,
                treeData: this.entityOptionData,
                sanitizedData: null,

                treeJson: null,
            }
        },
        mounted() {
            breadthFirstSearch(this.treeData, node => {
                node.open = false
            })
        },
    };
</script>

<style scoped lang="scss">
    .tree.draggable{
        .draggable-item{
            padding: 5px 50px 5px 10px;
            &:before{
                position: absolute;
                right: 14px;
                top: 10px;
                font: normal normal normal 23px LineAwesome;
                content: "\f131";
                color: #abb3ca;
            }
            &.has-children{
                padding: 5px 50px 5px 45px;
            }
        }
    }
    .draggable-item{
        position: relative;
        display: block;
        margin: 5px 0;
        padding: 5px 10px 5px 40px;
        color: #333;
        text-decoration: none;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 2px;
        background: #fff;
        border: solid 1px rgba(57, 81, 155, 0.3);
        font-size: 13px;
        font-weight: normal;
        line-height: 38px;
        &:before{
            position: absolute;
            content:"";
            width: 9px;
            height: 9px;
            background-color: #c3cae2;
            top: calc(50% - 4px);
            left: 15px;
            border-radius: 50%;
        }
        &.has-children{
            padding: 5px 10px 5px 45px;
        }
        .item-contents{
            float: left;
        }
        .btn-editable{
            float: right;
        }
        .btn-toggle-nested{
            position: absolute;
            left: 0;
            top:0;
            bottom:0;
            width: 35px;
            border-right: 1px solid #c2cae1;
            background-color: #edeff4;
            text-align: center;
            color: #c2cae1;
            font-size: 16px;
            line-height: 47px;
            &:hover{
                color: #7385b7;
            }
        }
        .info-container{
            float: right;
            color: #abb3ca;
            font-size: 19px;
            i{
                padding: 0 15px 0 10px;
                &.fa-lightbulb-o{
                    font-size: 16px;
                    padding: 0 12px 0 10px;
                    border-right: 1px solid #c2cae1;
                }
            }
        }
    }
    .card-empty-tree{
        background-color: transparent;
        border:2px dashed #d1d4d6;
        p{
            font-size: 15px;
            color: #969696;
        }
    }
</style>
